import { render, staticRenderFns } from "./RfqSummaries.vue?vue&type=template&id=74384ea5"
import script from "./RfqSummaries.vue?vue&type=script&lang=js"
export * from "./RfqSummaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports